import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { batch } from 'react-redux'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { jdihSetIsEventFilter, jdihSetKeyword, jdihSetSelected, jdihSetSkip, jdihSetYear } from '@/reducers/jdih'
import { getJdihHeader } from '@/services/jdih'
import { generateArrayObjects } from '@/utils/form'
import { useAppDispatch, useAppSelector } from '@/utils/hooks'

import SearchBar from './components/SearchBar'
import SelectComponent from './components/SelectComponent'

interface BannerProps {
  section?: string
}

const Banner: React.FC<BannerProps> = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const router = useRouter()
  const jdihKeyword = useAppSelector((state) => state.Jdih.keyword)
  const jdihYear = useAppSelector((state) => state.Jdih.year)
  const years = [{ label: t('common:year'), value: '' }].concat(generateArrayObjects())

  const { data: jdihBanner } = useAppSelector(
    getJdihHeader.select({
      headers: { 'Accept-Language': String(router.locale) },
    })
  )

  const handleReset = () => {
    batch(() => {
      dispatch(jdihSetIsEventFilter(true))
      dispatch(jdihSetSkip(0))
      dispatch(jdihSetSelected(0))
      dispatch(jdihSetYear(''))
      dispatch(jdihSetKeyword(''))
    })
  }

  return (
    <div className='relative w-full'>
      <div className='absolute inset-0 z-0 h-[150px] lg:h-full'>
        <div className='absolute inset-0 z-20 bg-black/20' />

        {jdihBanner?.data.imageFiles && (
          <ImageByWidthDevice
            images={jdihBanner?.data.imageFiles}
            alt='background image'
            className='h-full w-full object-cover object-center'
          />
        )}
      </div>

      <div className='container relative z-20 flex flex-col items-center justify-center gap-4 pb-0 text-white lg:py-20'>
        <p className='text-xl font-bold leading-normal lg:text-[28px]'>{t('jdih:banner.text')}</p>

        <div className='flex w-full flex-col gap-3 rounded-lg bg-white p-3 shadow-card lg:flex-row'>
          <SearchBar placeholder={t('jdih:banner.searchPlaceholder') as string} />

          <div className='lg:shrink-0 lg:basis-40'>
            <SelectComponent
              options={years}
              placeholder={t('jdih:banner.selectYearPlaceholder') as string}
            />
          </div>

          <button
            type='button'
            className='flex items-center justify-center rounded-full bg-red px-6 py-3 font-bold text-white disabled:bg-action-disabled disabled:text-form-disable-background'
            onClick={handleReset}
            disabled={jdihKeyword === '' && jdihYear === ''}
          >
            {t('common:reset')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Banner
